import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { populateExcelWorksheet } from 'bricks/utils';
import { IProFormaExcelData } from './types';

export const exportProFormaToExcel = async (data: IProFormaExcelData): Promise<void> => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Northspyre';
    workbook.created = new Date();
    workbook.modified = new Date();

    data.sheets.forEach(sheet => {
        const worksheet = workbook.addWorksheet(sheet.sheetName, {
            pageSetup: { orientation: 'landscape' },
            views: [{ showGridLines: false }],
        });

        populateExcelWorksheet(worksheet, sheet.sheetData, false, []);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${data.fileName}.xlsx`);
};
